import { AfterViewInit, Component, Inject } from '@angular/core';
import { MAT_BOTTOM_SHEET_DATA, MatBottomSheet } from '@angular/material/bottom-sheet';
import { FormGroup } from '@angular/forms';
import { FormlyFormOptions } from '@ngx-formly/core';

@Component({
  selector: 'confirm',
  styles: [
    `
      .actions-container {
        // Equivalente a fxLayout="row"
        display: flex;
        flex-direction: row;

        // Equivalente a fxLayoutGap="8px"
        gap: 8px;

        // Equivalente a fxFill (ocupa altura e largura totais do pai)
        width: 100%;
        height: 100%;
        box-sizing: border-box;

        // Equivalente a fxLayout.xs="column"
        // O breakpoint padrão do fxLayout xs é < 600px
        @media (max-width: 599px) {
          flex-direction: column;
        }
      }

      .action-item {
        // Equivalente a fxFlex="100" no container filho
        // Faz o item crescer e ocupar espaço igual
        flex: 1;

        // Garante que o conteúdo não estoure
        min-width: 0;
        display: flex; // Para garantir que o botão dentro estique se necessário
      }

      // Classe auxiliar para garantir que o botão ocupe 100% do wrapper
      // (Já que removemos fxFlex="100" do próprio botão)
      .full-width-btn {
        width: 100%;
        // Se 'w-full' já existir no seu CSS global (Tailwind/Utility), 
        // essa classe pode ser redundante, mas garante o comportamento.
      }
    `
  ],
  template: `
    <div elementSpacing="mar-spacing-default-xl"></div>
    
    @if (data?.icon) {
      <mat-icon>{{ data.icon }}</mat-icon>
    }
    @if (data?.icon) {
      <div elementSpacing="mar-spacing-default-md"></div>
    }
    
    <h1 textStyle="mar-label-lg" color="mar-text-primary">{{ data.title }}</h1>
    <div elementSpacing="mar-spacing-default-md"></div>
    
    <div mat-dialog-content>
      @if (!data.messageDisable) {
        <p textStyle="mar-body-sm" color="mar-text-tertiary" [innerHTML]="data.message"></p>
        <div elementSpacing="mar-spacing-default-2xl"></div>
      }
      @if (formConfig?.fields?.length > 0) {
        <br/>
        <formly-form
          [fields]="formConfig?.fields ?? []"
          [form]="formConfig?.form"
          [model]="values"
          [options]="formConfig?.options"
          (modelChange)="onChange($event)"
        ></formly-form>
      }
    </div>
    @if (data?.buttonCancel?.show || data?.buttonConfirm?.show) {
      <div mat-dialog-actions class="pb-4">
        <div class="actions-container">
          @if (data?.buttonCancel?.show) {
            <div class="action-item">
              <button
                siraButton
                variant="tertiary"
                [full]="true"
                type="button"
                (click)="matBottomSheet.dismiss(false)"
              >
                {{ data?.buttonCancel?.label }}
              </button>
            </div>
          }
          @if (data?.buttonConfirm?.show) {
            <div class="action-item">
              @if (!!formConfig) {
                <button
                  siraButton
                  variant="primary"
                  [full]="true"
                  type="button"
                  (click)="submit()"
                >
                  {{ data?.buttonConfirm?.label }}
                </button>
              } @else {
                <button
                  siraButton
                  variant="primary"
                  [full]="true"
                  type="button"
                  (click)="matBottomSheet.dismiss(true)"
                >
                  {{ data?.buttonConfirm?.label }}
                </button>
              }
            </div>
          }
  
    
        </div>
      </div>
    }
    `,
  standalone: false
})
export class ConfirmBottomComponent implements AfterViewInit {
  formConfig: any;
  values: any;

  constructor(
    public matBottomSheet: MatBottomSheet,
    @Inject(MAT_BOTTOM_SHEET_DATA) public data: any,
  ) {
  }

  ngAfterViewInit(): void {
    if (this.data?.formConfig?.fields) {
      const form = new FormGroup({});
      const options: FormlyFormOptions = {};
      this.formConfig = {
        form,
        options,
        ...this.data?.formConfig,
      };
    }
  }

  protected submit() {
    this.matBottomSheet.dismiss(this.values);
  }

  onChange(values: Record<string, any>) {
    this.matBottomSheet.dismiss(values);
  }
}
